<h1 mat-dialog-title class="expiration-title">Expiration date</h1>
<div mat-dialog-content class="expiration-content">
  Your access to this model's publications will expire on <span class="expiration-date">{{data.expirationDate}}</span>. To renew your subscription please go to the Marketplace.
</div>
